import { AuthorizationSSOConfiguration } from 'frontcore/domain/authorization/model/types'
import {
  AuthorizationSSOService,
  AuthorizationSSOView,
} from 'frontcore/domain/authorization/model/AuthorizationService.d'
import { AuthorizationSSOServiceFactory } from 'frontcore/domain/authorization/factory'
import { ref } from 'vue'

type Emits = {
  (e: 'error', message: string): void,
  (e: 'loginSuccess'): void,
}

class UseSSOLogin implements AuthorizationSSOView {

  readonly #applicationId?: string
  readonly #emit: Emits
  readonly #error = ref<string | null>(null)
  readonly #loading = ref(false)
  readonly #service: AuthorizationSSOService

  constructor (
    configuration: AuthorizationSSOConfiguration,
    emit: Emits,
    applicationId?: string
  ) {
    this.#applicationId = applicationId
    this.#emit = emit
    this.#service = AuthorizationSSOServiceFactory.build(configuration, this)
  }

  didFulfillLogin (error: string | null): void {
    this.#error.value = error
    this.#loading.value = error === null
    if (error !== null) {
      this.#emit('error', error)
    } else {
      this.#emit('loginSuccess')
    }
  }

  use () {
    const login = () => {
      const store = { applicationId: this.#applicationId }
      this.#loading.value = true
      this.#service.ssoLogin(store)
    }
    return {
      error: this.#error,
      loading: this.#loading,
      login,
    }
  }

}

export default UseSSOLogin
